export default "__VITE_ASSET__39c7c816__"